import { render, staticRenderFns } from "./LinkBox.vue?vue&type=template&id=39b25b5d&scoped=true&"
import script from "./LinkBox.vue?vue&type=script&lang=js&"
export * from "./LinkBox.vue?vue&type=script&lang=js&"
import style0 from "./LinkBox.vue?vue&type=style&index=0&id=39b25b5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b25b5d",
  null
  
)

export default component.exports